export default __webpack_public_path__ + "static/media/fondo_grecas.60dc6f4d.png";